import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Typography, FormControlLabel, Checkbox } from '@mui/material';
import Split from '../../../../../split';

const MobileAppWorkflow = ({ props }) => {
    const shouldRender = Split.getBooleanTreatment('can_manage_mobile_app_processor_workflow');

    if (!shouldRender) {
        return null;
    }

    const { fields, isProcessorForm, hideTitle } = props;
    const { setValue, watch, getValues } = useFormContext();
    const defaultValues = getValues();
    const title = 'Mobile App Workflow'[isProcessorForm ? 'toString' : 'toUpperCase']();

    return (
        <Box display="flex" flexDirection="column">
            {!hideTitle && (
                <Typography
                    variant={isProcessorForm ? 'h5' : 'body1'}
                    fontWeight={600}
                    sx={{
                        ...(!isProcessorForm && { opacity: 0.8 }),
                        marginY: 2,
                    }}
                    //
                >
                    {title}
                </Typography>
            )}
            {fields?.map((field, index) => {
                const isChecked = watch(field.name) ?? defaultValues[field.name];

                const handleChange = (e) => {
                    setValue(field.name, e.target.checked);
                };

                return (
                    <FormControlLabel
                        key={field.name}
                        control={<Checkbox checked={!!isChecked} onChange={handleChange} />}
                        label={field.label}
                        //
                    />
                );
            })}
        </Box>
    );
};

export default MobileAppWorkflow;
